export default {
  namespaced: true,
  presets_ptz: {
    title: "preset | presets",
    id_camera: "cámara id",
    presets: "preajustes",
  },
};
